import React, { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DemoPage() {
  const [error, setError] = useState('');
  const [status, setStatus] = useState('CONNEXION DEMO...');

  useEffect(() => {
    // Immediately call demo API with raw fetch
    setStatus('CONNEXION...');
    fetch(`${API}/auth/demo`, { credentials: 'include' })
      .then(r => r.json())
      .then(data => {
        if (data.token) {
          localStorage.setItem('auth_token', data.token);
          localStorage.setItem('auth_user', JSON.stringify(data));
          setStatus('OK! REDIRECTION...');
          // Hard redirect to dashboard — bypasses React Router entirely
          window.location.href = '/dashboard';
        } else {
          setError('Pas de token reçu');
        }
      })
      .catch(e => {
        console.error(e);
        setError('Erreur de connexion');
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center">
      {error ? (
        <div className="text-center">
          <p className="font-mono text-[#E61C24] text-lg mb-4">{error}</p>
          <a href="/login" className="font-heading text-sm uppercase text-[#00AEEF] border border-[#00AEEF] px-6 py-2 inline-block">LOGIN</a>
        </div>
      ) : (
        <div className="text-center">
          <div className="font-mono text-2xl text-[#39FF14] animate-pulse">{status}</div>
          <div className="mt-4 flex gap-2 justify-center">
            {[0,1,2].map(i => (
              <div key={i} className="w-3 h-3 bg-[#E61C24] rounded-full animate-bounce" style={{ animationDelay: `${i*0.2}s` }} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
